export const tools = {
  makeCapitalCase: (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.toLowerCase().slice(1);
  },
  toLowerCase: (s) => {
    if (typeof s !== "string") return "";
    return s.toLowerCase();
  },
  parseBool: (str) => {
    let val = false;
    if (typeof str === "string") {
      if (str.trim().toLowerCase() === "true") {
        val = true;
      } else if (str.trim().toLowerCase() === "false") {
        val = false;
      }
      return val;
    } else {
      return str;
    }
  },
  justNumber: (str) => {
    let result = str.replace(/[^\d]/g, "");
    return result;
  },
  toEnDigit: (value) => {
    const toEnDigit = (n) => n?.replace(/[٠-٩۰-۹]/g, (n) => 15 & n.charCodeAt(0));
    return toEnDigit(value);;
  },


  justEnglish: (value) => {
    return `${value}`.replace(/[^a-zA-Z\s]/g, "");
  },

  isObject: (data) => {
    return data && typeof data === "object";
  },

  toObject(data) {
    return this.isObject(data) ? data : {};
  },

  isArray: (data) => {
    return data && typeof data === "object" && data.constructor === Array;
  },
  toArray(data) {
    return this.isArray(data) ? data : [];
  },
  arrayPad: (arr, len, fill) => {
    return arr.concat(Array(len).fill(fill)).slice(0, len);
  },

  jsonDecode: (json) => {
    try {
      return JSON.parse(json);
    } catch (e) {
      return null;
    }
  },

  previewFile: (fileBlob, callback = () => { }) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(fileBlob);
  },

  joinDurationObject: (duration) => {
    const { hours, minutes, seconds } = duration || {};
    const array = [];
    if (hours) {
      array.push(`${hours} hours`);
    }
    if (minutes) {
      array.push(`${minutes} minutes`);
    }
    if (seconds) {
      array.push(`${seconds} seconds`);
    }

    return array.join(" : ");
  },

  /**
   * Find specific field error message from errorArray
   * @param {{field: String, errorMessage: String}[]} errorArray
   * @param {string} fieldName the field's name that you want to look for into errorArray
   * @return {string} field error message if found. otherwise return empty string
   */
  findErrorMessage: (errorArray, fieldName) => {
    const t = errorArray.find((x) => x.field === fieldName);
    if (t) {
      return t.errorMessage;
    } else {
      return "";
    }
  },
  /**
   * Get Validation model, and input data object then return result array that we can store it into errors Array. if there is no error, it will be empty
   * @param {Schema} validationModelSchema
   * @param {Object} inputObject object of values that contain field's name for each input
   * @return {{field: String, errorMessage: String}[]}
   */
  applyModelCheckValidation: (validationModelSchema, inputObject) => {
    let result = [];
    const checkResult = validationModelSchema.check(inputObject);
    for (let key in checkResult) {
      let value = checkResult[key];
      if (value.hasError) {
        result.push({ field: key, errorMessage: value.errorMessage });
      }
    }
    return result;
  },
  isMobile() {
    return window.innerWidth <= 768;
  },

  splitNumberForPrice(number) {
    if (number === "" || number === undefined) return 0;

    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};
